import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "components/button";

type Props = {
    onClose: () => void;
};

const OptionsModal: React.FC<Props> = ({ onClose }) => {
    const [qbolLineItems, setQbolLineItems] = useState<boolean>(false);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_SERVER_URL}/api/v1/company/quickbooks-online/business-options`
                );
                if (typeof res.data?.qbol_line_items === "boolean") {
                    setQbolLineItems(res.data.qbol_line_items);
                }
            } catch (error) {
                console.error("Failed to fetch settings", error);
            }
        };
        fetchSettings();
    }, []);

    const handleSave = async () => {
        try {
            await axios.put(
                `${process.env.REACT_APP_SERVER_URL}/api/v1/company/quickbooks-online/business-options`,
                { qbolLineItems }
            );
            onClose();
        } catch (error) {
            console.error("Failed to save settings", error);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-[400px] max-h-[80vh]">
                <h2 className="text-xl font-semibold mb-4">Invoice Sync Mode</h2>
                <div className="mb-6">
                    <label className="block mb-2 font-medium">Select sync mode:</label>
                    <select
                        className="border rounded px-2 py-1 w-full"
                        value={qbolLineItems ? "line_items" : "subtotal"}
                        onChange={(e) => setQbolLineItems(e.target.value === "line_items")}
                    >
                        <option value="subtotal">Sync Subtotal Only</option>
                        <option value="line_items">Sync Full Line Items</option>
                    </select>
                </div>

                <div className="flex justify-end">
                    <Button className="mr-2" onClick={handleSave}>
                        Save
                    </Button>
                    <Button onClick={onClose}>Close</Button>
                </div>
            </div>
        </div>
    );
};

export default OptionsModal;
